import ExpandMore from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import API from '../../../services/API'
import moment from 'moment'

const TYPE_LABEL = { check: 'Full Check', quick_add: 'Quick Top-up' }

// Read-only view onto the make-ready audit trail already being recorded
// server-side on every check (see MakeReadyReport/MakeReadyHistory) - shown
// per vehicle/asset. Renders as an accordion by default (asset page); pass
// `plain` to render just the table with an eager fetch (vehicle page tabs).
const MakeReadyHistoryAccordion = ({ assetOrVehicleId, plain = false }) => {
  const [expanded, setExpanded] = useState(false)
  const [loading, setLoading] = useState(true)
  const [history, setHistory] = useState([])
  const [downloadDone, setDownloadDone] = useState(false)

  useEffect(() => {
    if (history.length === 0 && !downloadDone && (plain || expanded)) {
      API.get(`/makeready/history/${assetOrVehicleId}`)
        .then((res) => {
          if (res.status === 200) {
            setHistory(res.data.history)
            setDownloadDone(true)
          }
        })
        .catch((e) => console.error(e))
        .finally(() => setLoading(false))
    }
  }, [expanded, plain])

  const content = (
    <>
      {loading && <LinearProgress />}
      {!loading && downloadDone && history.length === 0 ? (
        <Alert severity="info">No make ready checks recorded yet</Alert>
      ) : (
        !loading && (
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  '.MuiTableCell-head': {
                    fontWeight: 'bold',
                  },
                }}
              >
                <TableCell>Date</TableCell>
                <TableCell>Checked By</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Summary</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map((record) => (
                <TableRow key={record._id}>
                  <TableCell>
                    {moment(record.createdAt).format('DD/MM/YYYY HH:mm')}
                  </TableCell>
                  <TableCell>
                    {record.checkedBy
                      ? `${record.checkedBy.firstName ?? ''} ${
                          record.checkedBy.lastName ?? ''
                        }`.trim()
                      : '-'}
                  </TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={TYPE_LABEL[record.source] || record.source}
                      color={record.source === 'quick_add' ? 'info' : 'default'}
                    />
                  </TableCell>
                  <TableCell>{record.summary}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )
      )}
    </>
  )

  if (plain) return content

  return (
    <Accordion expanded={expanded} disableGutters>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant="title2">History</Typography>
      </AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
    </Accordion>
  )
}

export default MakeReadyHistoryAccordion
